import { push } from 'redux-little-router';
import size from 'lodash/size';
import {presentSubviewIdentifier, presentModelUrl} from "~/statePresenter";
import {
    getLoadedModels, getModelNameOrNull, getModels, getParentId, getSetCurrentModelId,
    getSubview,
    getSubviews,
} from "~/stateGetter";
import getConfig from "~/config";
import {downloadWebsailFile, getDownloadUrl} from "~/backend/backendUrl";
import {pushHelpPath} from "~/actions/help_actions";

export function pushModelPath(modelId, path, options, ...args) {
    return (dispatch, getState) => {
        let state = getState(),
            loadedModels = getLoadedModels(state),
            models = getModels(state, modelId);

        let modelUrl = presentModelUrl({loadedModels, modelId, models, ...options});
        path = getNormalizedPath(path);
        path.pathname = `${modelUrl}${path.pathname}`;
        return dispatch(push(path, ...args));
    }
}

export function pushCurrentModelHelpPath(...args) {
    return (dispatch, getState) => {
        let state = getState(),
            modelId = getSetCurrentModelId(state),
            modelName = getModelNameOrNull(state, modelId);

        return dispatch(pushHelpPath(modelName, {}, ...args));
    }
}

export function pushCurrentModelPath(path, options, ...args) {
    return (dispatch, getState) => {
        let state = getState(),
            modelId = getSetCurrentModelId(state);

        return dispatch(pushModelPath(modelId, getNormalizedPath(path), options, ...args));
    }
}

export function pushSubview(modelId, subviewName, path = '', ...args) {
    return (dispatch, getState) => {
        let state = getState(),
            subviews = getSubviews(state, modelId),
            subview = getSubview(state, modelId, subviewName),
            identifier = presentSubviewIdentifier({subviews, subview});

        const hasQuery =path.query && size(path.query) > 0;

        path = getNormalizedPath(path);
        path.pathname = hasQuery ? "" : `/${identifier}${path.pathname}`;

        dispatch(pushCurrentModelPath(path, { includeCurrent: true, includeItemId: true }, ...args));
    };
}

export function pushClose(...args) {
    return (dispatch, getState) => {
        let state = getState(),
            modelId = getSetCurrentModelId(state),
            parentModelId = getParentId(state, modelId);
            // closeModelId = getCloseModelId(state, modelId);

        if(parentModelId) {
            return dispatch(pushModelPath(parentModelId, '', { includeCurrent: true, includeItemId: true, includeMode: true }, ...args));
        }

        return dispatch(pushModelPath(modelId, '', { includeCurrent: true }, ...args));
    };
}

export function smartGoto(url, options = {}, shouldReplace = true) {
    return (dispatch, getState) => {
        let match = url.match(/\/admin([^?]+)/);

        if(match) {
            return dispatch(push(match[1], options));
        }

        const openHandle = window.open(url, '_blank');
        // popups can be blocked and in that case the window is null
        if(openHandle) {
            openHandle.focus();
        } else {
            window.location.href = url;
        }
    };
}

export function openActionResult(result, options = {}) {
    return (dispatch, getState) => {
        if(result.downloadId) {
            let supportedMimeTypes = getConfig().openMimeTypes;
            if(result.mimeType && supportedMimeTypes.filter(m => result.mimeType.indexOf(m) > -1).length) {
                return window.open(getDownloadUrl(result.downloadId), '_blank');
            }

            return downloadWebsailFile(result.downloadId);
        }

        if(result.redirect) {
            return dispatch(smartGoto(result.redirect, options));
        }
    }
}


export function pushWithAbsoluteLinks(url, options) {
    return (dispatch) => {
        if (!url) {
            return;
        }

        if (url.startsWith("http")) {
            return dispatch(smartGoto(url, options))
        }

        return dispatch(push(url, options))
    }
}

export function getNormalizedPath(path) {
    const pathObject = typeof path === "string" ? {
        pathname: path
    } : path
    return pathObject
}